const molecularBiomarkers = {
    listTitle: 'Alterations detected',
    seeList: 'see list view',
    generalErrors: {
        unknown: {
            title: 'Something went wrong',
            description:
                'Drivers and Biomarkers could not be loaded from the server.'
        },
        accessDenied: {
            title: 'Access Denied',
            description:
                'You have no permission to view drivers and biomarkers.'
        }
    }
}

export default molecularBiomarkers
